export const GRIPPER_FORCE_NEWTONS_DEFAULT = 45;
export const GRIPPER_FORCE_PERCENT_DEFAULT = 0.5;
export const GRIPPER_GRIP_KIND_DEFAULT = 'inward';

// default diameter for the form should be accessible by any gripper
export const GRIPPER_DIAMETER_MM_DEFAULT = 45;

// Tolerance applied when a command carries no explicit one. Shared so the
// wizard default and the driver-side fallback can't drift apart.
export const GRIPPER_TOLERANCE_METERS_DEFAULT = 0.003;
